import styled, { css } from "styled-components";

import { colorsPalettes, rgba, setElevation } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import type { OnboardingDialogVariant } from "./variants";

/* Matches the modal overlay z-index in `@similarweb/ui-components`, which clears the SI sidebar (1055). */
const OVERLAY_Z_INDEX = 1070;

const VARIANT_STYLES = {
    wizard: {
        overlayBackground: colorsPalettes.bluegrey[100],
        closeIconOffset: "16px",
        panel: css`
            width: 940px;
            max-width: 940px;
            height: 644px;
            max-height: 720px;
            border-radius: 10px;
            /* Z1_hover is the elevation token that holds the shadow this modal has always used. */
            ${setElevation("Z1_hover")}
        `,
    },
    info: {
        overlayBackground: rgba(colorsPalettes.midnight[300], 0.7),
        closeIconOffset: "32px",
        panel: css`
            width: 455px;
            max-width: 455px;
            max-height: 600px;
            border: 0.5px solid transparent;
            border-radius: 6px;
            ${setElevation("Z4")}
        `,
    },
} as const satisfies Record<OnboardingDialogVariant, unknown>;

export const StyledDialogOverlay = styled(Flex)<{ $variant: OnboardingDialogVariant }>`
    position: fixed;
    inset: 0;
    z-index: ${OVERLAY_Z_INDEX};
    box-sizing: border-box;
    flex-direction: column;
    padding: 16px;
    overflow-y: auto;
    /* Without this the page behind keeps scrolling once the overlay has nothing left to scroll. */
    overscroll-behavior: contain;
    background-color: ${({ $variant }) => VARIANT_STYLES[$variant].overlayBackground};
`;

export const StyledDialogPanel = styled(Flex)<{ $variant: OnboardingDialogVariant }>`
    position: relative;
    flex-direction: column;
    flex-shrink: 0;
    gap: 16px;
    box-sizing: border-box;
    margin: auto;
    overflow: hidden;
    outline: none;
    background-color: ${colorsPalettes.carbon[0]};
    ${({ $variant }) => VARIANT_STYLES[$variant].panel}
`;

export const StyledCloseIconWrapper = styled.div<{ $variant: OnboardingDialogVariant }>`
    position: absolute;
    top: ${({ $variant }) => VARIANT_STYLES[$variant].closeIconOffset};
    right: ${({ $variant }) => VARIANT_STYLES[$variant].closeIconOffset};
    z-index: 10;
`;
